.dropdownButton {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
